import {

  GET_EMPLOYEES_FAIL,
  GET_EMPLOYEES_SUCCESS,
 
  GET_EMPLOYEE_DETAIL_SUCCESS,
  GET_EMPLOYEE_DETAIL_FAIL,

  GET_AUTH_USER_SUCCESS,
  GET_AUTH_USER_FAIL,
  DELETE_EMPLOYEE_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  employees: [],
 
  employee: {},
}

const Employees = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: action.payload,
      }

    case GET_EMPLOYEES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    
    case GET_EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...state,
        employee: action.payload,
      }

    case GET_EMPLOYEE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_EMPLOYEE_SUCCESS: 
      return {
        ...state,
        employees: state.employees.docs.filter(
          employee => employee._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Employees
